module.exports = __webpack_public_path__ + "img/logo2.d7047e61.svg";